// PRODUCTION COMPONENT LISTING

import { PRODUCTION_COMPONENT, PRODUCTION_COMPONENT_UP_DEL } from "../../constants/apis";
import { getUrl, replaceMultiple } from "../../utilities/helpers";

export const fetchProductionComponents =
  (uuid, query) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(PRODUCTION_COMPONENT, {
      "{{uuid}}": uuid,
    });
    const url = getUrl(finalUrlPath, query);
    return apiReport
      .get(url)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

// PRODUCTION COMPONENT CREATE

export const createProductionComponents =
  (uuid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(PRODUCTION_COMPONENT, {
      "{{uuid}}": uuid,
    });
    return apiReport
      .post(finalUrlPath, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };

// PRODUCTION COMPONENT UPDATE

export const updateProductionComponents =
  (uuid, produtionCompid, payload) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(PRODUCTION_COMPONENT_UP_DEL, {
      "{{uuid}}": uuid,
      "{{productionid}}": produtionCompid,
    });
    return apiReport
      .put(finalUrlPath, payload)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };
// PRODUCTION COMPONENT DELETE
export const deleteProductionComponents =
  (uuid,produtionCompid) =>
  (dispatch, getState, { apiReport }) => {
    const finalUrlPath = replaceMultiple(PRODUCTION_COMPONENT_UP_DEL, {
      "{{uuid}}": uuid,
      "{{productionid}}": produtionCompid,
    });
    return apiReport
      .delete(finalUrlPath)
      .then((result) => result)
      .catch((error) => {
        throw error;
      });
  };